import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

const Item = ({ link, text, icon }: { link: string; text: string; icon: React.ReactNode }) => {
	return (
		<ListItem
			disablePadding
			sx={{ display: "block" }}>
			<ListItemButton
				href={link}
				sx={{
					minHeight: 48,
					px: 2.5,
				}}>
				<ListItemIcon
					sx={{
						minWidth: 0,
						justifyContent: "center",
						mr: 3,
					}}>
					{icon}
				</ListItemIcon>
				<ListItemText primary={text} />
			</ListItemButton>
		</ListItem>
	);
};

export default Item;
